import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useState } from "react";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import Constants from "expo-constants";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Toast } from "react-native-toast-notifications";
import * as WebBrowser from "expo-web-browser";
import i18n from "../../../../locales/i18n";
import StandardNavigation from "../../../../components/navigation/StandardNavigation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import Animated, { FadeInDown } from "react-native-reanimated";
const Update = () => {
  const { needNewUpdate, locale } = useSelector(
    (state: RootState) => state.app
  );
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0); // State for download progress

  const handelGetVersion = async () => {
    setButtonSpinner(true);
    setDownloadProgress(0);

    if (!needNewUpdate) {
      Toast.show(i18n.t("alreadyLatestVersion"), { type: "success" });
      setButtonSpinner(false);
    } else {
      try {
        await WebBrowser.openBrowserAsync("https://khdame.com/download/", {
          enableBarCollapsing: true,
          showTitle: false,
        });
      } catch (error: any) {
        Toast.show(`${i18n.t("errorOccurred")}: ${error?.message}`, {
          type: "danger",
        });
      } finally {
        setButtonSpinner(false);
        setDownloadProgress(0);
      }
    }
  };
  const appVersion = Constants.expoConfig?.version;

  return (
    <View style={{ flex: 1, backgroundColor: "#f5f5f5" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        title={i18n.t("updateapp")}
        showBackButton={true}
        showMenuButton={true}
        showLogo={true}
      />

      <ScrollView style={{ flex: 1 }}>
        <View className="p-4 w-full h-screen">
          <Animated.View
            entering={FadeInDown.duration(400).delay(100)}
            className={`  ${locale === "ar" ? "flex-row" : "flex-row-reverse"} 
             mt-4 border w-full rounded-xl justify-between p-3 `}
          >
            <LinearGradient
              colors={["rgba(19, 121, 162, 1)", "rgba(5, 150, 208, 1)"]}
              style={{
                alignItems: "center",
                borderWidth: 1,
                justifyContent: "center",
                borderRadius: 12,
                paddingHorizontal: 8,
              }}
            >
              <Text
                style={{ fontFamily: "kawkabBold" }}
                className={"text-center text-white font-bold px-2"}
              >
                {appVersion}
              </Text>
            </LinearGradient>
            <Text
              style={{ fontFamily: "kawkabBold" }}
              className={"text-right text-black w-48"}
            >
              {i18n.t("currentversion")}
            </Text>
          </Animated.View>
          <Animated.View entering={FadeInDown.duration(400).delay(200)}>
            <TouchableOpacity
            disabled={!needNewUpdate}
            onPress={handelGetVersion}
            className={`w-full ${
              !needNewUpdate ? "opacity-40" : "opacity-100 "
            }        `}
          >
            <View
              className={`    ${
                needNewUpdate ? "bg-red-200  " : "bg-white"
              }     ${
                locale === "ar" ? "flex-row" : "flex-row-reverse"
              }   mt-4 border w-full rounded-xl items-center justify-between p-3`}
            >
              {needNewUpdate && (
                <View className="  absolute z-50 left-[110px]  rounded-full ">
                  <Ionicons
                    // style={{ width: 20, height: 20,  }}
                    name="notifications"
                    size={30}
                    color="red"
                  />
                </View>
              )}
              <MaterialIcons name="system-update-tv" size={35} color="black" />
              <Text
                style={{ fontFamily: "kawkabBold" }}
                className={"text-right text-black   "}
              >
                {i18n.t("updateNewVersion")}
              </Text>
            </View>
          </TouchableOpacity>
          </Animated.View>
          {/* Loader and Progress Percentage */}
          {buttonSpinner && needNewUpdate && (
            <View className="mt-8 items-center">
              <ActivityIndicator size="large" color="green" />
              <Text className="mt-2 text-center  text-black">
                {i18n.t("downloading")} {downloadProgress.toFixed(2)}%
              </Text>
            </View>
          )}
        </View>
      </ScrollView>
    </View>
  );
};

export default Update;
